import axios from 'axios';
import { URLS } from '@constants/urls';
import api from '@helpers/api';
import { encodeQuery } from '@pentabd/ui';

export const getDashboardDivisionCenters = (() => {
  const cancelToken = axios.CancelToken;
  let source = cancelToken.source();
  let isRequestInProcess = false;

  return async ({
    divisionId,
    asonId,
    election_schedule_id,
  }: {
    divisionId: number;
    asonId: number;
    election_schedule_id: number | string;
  }): Promise<{ data: any }> => {
    if (isRequestInProcess) {
      source.cancel();
      source = cancelToken.source();
    }

    isRequestInProcess = true;

    return api
      .get(
        encodeQuery(URLS.GET_DASHBOARD_DIVISION_CENTERS(divisionId, asonId), {
          election_schedule_id,
        }),
      )
      .then((response) => {
        return { data: response.data };
      })
      .finally(() => {
        isRequestInProcess = false;
      });
  };
})();
